// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import '../../sections/header/header';
import '../../sections/hero-banner/hero-banner';
import '../../sections/hero-banner/hero-banner--carousel';
import '../../sections/hero-banner/hero-banner--slider';
import '../../sections/intro-block/intro-block';
import '../../sections/collection-list/collection-list';
import '../../sections/banner/banner-block';
import '../../sections/icon-block/icon-block';
import '../../sections/veritree-stats/veritree-stats';
import '../../sections/collection-footer/collection-footer';
import '../../sections/content-panel/content-panel';
import '../../sections/faqs/faqs';
import '../../sections/testimonial/testimonial';
import '../../sections/featured-collection/featured-collection';
import '../../sections/blog-posts/blog-posts';
import '../../sections/newsletter/newsletter';
import 'sections/feature-highlight/feature-highlight';
import '../../sections/footer/footer';

// Styles
